import { Checkbox, Dialog, DialogContent, DialogTitle, Grid, IconButton, Tooltip } from "@mui/material";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import React, { useState } from "react";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { TbTxt } from "react-icons/tb";
import { IconContext } from "react-icons";
import { BsMarkdownFill } from "react-icons/bs";
import { useTheme } from "@emotion/react";
import { exportToMarkdown, exportToText, exportBookmarks, exportToPDF } from "../Export"

const ExportBoard = ({
                    embedId,
                    title,
                    openExportDialog,
                    setOpenExportDialog,
                    bookmarks
                }) => {
    
    const theme = useTheme();
    const [clipboard, setClipboard] = useState(false);

    const handleClipboard = (event) => {
        setClipboard(event.target.checked)
    }
    
    // Export to Markdown
    const handleExportToMarkdown = () => { 
        exportToMarkdown(title, bookmarks, embedId, clipboard)
    };
    
    // Export to PDF
    const handleExportToPDF = () => { 
        exportToPDF(embedId, title, bookmarks);
    };
    
    // Export to Text
    const handleExportToText = () => {
        exportToText(embedId, bookmarks, clipboard);
    };

    const handleExportBookmarks = () => {
        exportBookmarks(embedId, bookmarks)
    };

    return (
        <Dialog open={openExportDialog} onClose={() => {setOpenExportDialog(false); setClipboard(false)}}>
            <DialogTitle>Export Bookmarks</DialogTitle>
            <DialogContent>
                <FormGroup>
                    <FormControlLabel 
                        control={<Checkbox onChange={handleClipboard}/>}
                        label="to clipboard"
                    />
                </FormGroup>
                <Grid container spacing={2}>
                {!clipboard && <Grid item>
                    <Tooltip title="Export to PDF" arrow>
                    <IconButton onClick={handleExportToPDF}>
                        <PictureAsPdfIcon sx={{ color: theme.palette.primary.main, fontSize: '40px' }}/>
                    </IconButton>
                    </Tooltip>
                </Grid>}
                <Grid item>
                    <Tooltip title="Export to Markdown" arrow>
                    <IconButton onClick={handleExportToMarkdown}>
                        <IconContext.Provider
                            value={{ color: theme.palette.primary.main, size: '40px' }}
                            >
                            <div>
                                <BsMarkdownFill />
                            </div>
                        </IconContext.Provider>
                    </IconButton>
                    </Tooltip>
                </Grid>
                <Grid item>
                    <Tooltip title="Export to Text" arrow>
                    <IconButton onClick={handleExportToText}>
                        <IconContext.Provider
                            value={{ color: theme.palette.primary.main, size: '40px' }}
                            >
                            <div>
                                <TbTxt />
                            </div>
                        </IconContext.Provider>
                    </IconButton>
                    </Tooltip>
                </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}

export default ExportBoard;